export interface DocsNavItem {
  title: string
  description: string
  href: string
  section: string
  keywords: string
}

export const DOCS_NAV_ITEMS: DocsNavItem[] = [
  {
    title: 'What TokenDance provides',
    description: 'FDE teams, LLM APIs, model routing, evaluation loops, and production AI operations.',
    href: '/docs/what-TokenDance-can-do',
    section: 'FDE and LLM',
    keywords: 'TokenDance FDE forward deployed engineering LLM API gateway model routing evals agents GPU inference production AI',
  },
]

export function docsSections(items = DOCS_NAV_ITEMS) {
  return items.reduce<Array<{ title: string; items: DocsNavItem[] }>>((sections, item) => {
    const section = sections.find((entry) => entry.title === item.section)
    if (section) {
      section.items.push(item)
    } else {
      sections.push({ title: item.section, items: [item] })
    }
    return sections
  }, [])
}

export function filterDocs(query: string) {
  const q = query.trim().toLowerCase()
  if (!q) return DOCS_NAV_ITEMS

  return DOCS_NAV_ITEMS.filter((item) =>
    [item.title, item.description, item.section, item.keywords]
      .join(' ')
      .toLowerCase()
      .includes(q),
  )
}
